import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4894-8235

type ProfileCardProps = {
  imageSrc: string;
  name: string;
  /** Role and affiliation, e.g. "REI @ Terra Fertility". */
  title: string;
  /** Layout only. A repeated look is a variant. */
  className?: string;
};

// The 64px photo and 16px gap have no Figma variable (EVY-436).
// Display component, no ref forwarded. See ui/README.md.
export const ProfileCard = ({
  imageSrc,
  name,
  title,
  className,
}: ProfileCardProps) => (
  <div
    className={cn(
      "flex items-start gap-[16px] text-ds-text-primary",
      className
    )}
  >
    {/* The name beside it labels the photo, so it is decorative. */}
    <img
      src={imageSrc}
      alt=""
      loading="lazy"
      className="size-[64px] shrink-0 rounded-ds-corner-full object-cover"
    />
    <div className="flex min-w-0 flex-col gap-ds-space-02">
      <p className="m-0 ds-header-h6">{name}</p>
      <p className="m-0 ds-body-small-regular">{title}</p>
    </div>
  </div>
);
